var _metadata, _defs, _sodipodiNamedview;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlert(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsDc: "http://purl.org/dc/elements/1.1/",
    xmlnsCc: "http://creativecommons.org/ns#",
    xmlnsRdf: "http://www.w3.org/1999/02/22-rdf-syntax-ns#",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsSodipodi: "http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd",
    xmlnsInkscape: "http://www.inkscape.org/namespaces/inkscape",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    id: "svg4136",
    inkscapeVersion: "0.91 r13725",
    sodipodiDocname: "Alert Ico.svg",
    style: {
      fill: "none"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", {
    id: "metadata4150"
  }, /*#__PURE__*/React.createElement("rdfRDF", null, /*#__PURE__*/React.createElement("ccWork", {
    rdfAbout: ""
  }, /*#__PURE__*/React.createElement("dcFormat", null, "image/svg+xml"), /*#__PURE__*/React.createElement("dcType", {
    rdfResource: "http://purl.org/dc/dcmitype/StillImage"
  }), /*#__PURE__*/React.createElement("dcTitle", null))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs4148"
  })), _sodipodiNamedview || (_sodipodiNamedview = /*#__PURE__*/React.createElement("sodipodiNamedview", {
    pagecolor: "#ffffff",
    bordercolor: "#666666",
    borderopacity: 1,
    objecttolerance: 10,
    gridtolerance: 10,
    guidetolerance: 10,
    inkscapePageopacity: 0,
    inkscapePageshadow: 2,
    "inkscapeWindow-width": 1680,
    "inkscapeWindow-height": 987,
    id: "namedview4146",
    showgrid: "false",
    inkscapeZoom: 6.4425285,
    inkscapeCx: 6.0641935,
    inkscapeCy: 17.245387,
    "inkscapeWindow-x": -8,
    "inkscapeWindow-y": -8,
    "inkscapeWindow-maximized": 1,
    "inkscapeCurrent-layer": "svg4136",
    "fit-margin-top": 0,
    "fit-margin-left": 0,
    "fit-margin-right": 0,
    "fit-margin-bottom": 0
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4152",
    transform: "translate(0.45247861,-2.1941504)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e34b16"
    },
    "inkscapeConnector-curvature": 0,
    id: "path4140",
    d: "m 17.774341,5.6736893 12.97226,22.4691097 c 0.99,1.7139 -0.2475,3.8572 -2.22686,3.8572 l -25.9443998,0 c -1.97939999,0 -3.21689999,-2.1433 -2.22689999,-3.8572 L 13.320641,5.6736893 c 0.99,-1.71385 3.4637,-1.71385 4.4537,0 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff"
    },
    "inkscapeConnector-curvature": 0,
    id: "path4142",
    d: "m 14.261841,21.971099 2.5715,0 0.6428,-9 -3.8571,0 0.6428,9 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff"
    },
    "inkscapeConnector-curvature": 0,
    id: "path4144",
    d: "m 17.476141,25.828199 c 0,1.065201 -0.8633,1.9286 -1.9286,1.9286 -1.0652,0 -1.9285,-0.863399 -1.9285,-1.9286 0,-1.064499 0.8633,-1.9285 1.9285,-1.9285 1.0653,0 1.9286,0.864001 1.9286,1.9285 z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.5513c7359326cf083252a4289aa7b414.svg";
export { ForwardRef as ReactComponent };